import ClientUpdatesModule from "@/store/modules/clientUpdates.module";
import { assign, Machine } from "xstate";
// Last Count options: 1 to 5; the page opens on 1, the most recent update
export const LAST_COUNT_OPTIONS = [1, 2, 3, 4, 5];
export const DEFAULT_LAST_COUNT = 1;
const weeklyStandupMachine = Machine({
    id: "weeklyStandup",
    type: "parallel",
    context: {
        count: DEFAULT_LAST_COUNT,
        dateFrom: null,
        dateTo: null,
    },
    states: {
        // Opens on Last Count and loads straight away; a newer request replaces one still running
        reportInfo: {
            initial: "gettingReport",
            on: {
                GENERATE_REPORT: { target: ".gettingReport", actions: "assignReportFilter" },
            },
            states: {
                idle: {},
                gettingReport: {
                    invoke: {
                        id: "gettingReport",
                        src: (context, event) => {
                            return ClientUpdatesModule.GetWeeklyStandup({ count: context.count, from: context.dateFrom, to: context.dateTo });
                        },
                        onDone: { target: "loadedReport" },
                        onError: { target: "idle" },
                    },
                },
                loadedReport: {},
            },
        },
    },
}, {
    actions: {
        assignReportFilter: assign({
            count: (context, event) => event.count || null,
            dateFrom: (context, event) => event.dateFrom || null,
            dateTo: (context, event) => event.dateTo || null,
        }),
    },
    guards: {},
    activities: {},
    services: {},
});
export default weeklyStandupMachine;
